import Vue from 'vue'
import App from './App'
import VueRouter from 'vue-router'
import Bootstrap from 'bootstrap'
import Jquery from 'jquery'
import Popper from 'popper.js'
import { auth } from './db'

//Routes
import About from './components/About'
import Resume from './components/resume/Resume'
import Calculator from './components/calculator/Calculator'

//Fontawesome
import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faLinkedin,
  faTwitterSquare,
  faGithubSquare,
  faBlogger,
} from '@fortawesome/free-brands-svg-icons'
import {
  faUserCircle,
  faCodeBranch,
  faAngleDoubleUp,
  faAngleDoubleDown,
} from '@fortawesome/free-solid-svg-icons'
library.add(
  faLinkedin,
  faTwitterSquare,
  faGithubSquare,
  faBlogger,
  faUserCircle,
  faCodeBranch,
  faAngleDoubleUp,
  faAngleDoubleDown
)
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
Vue.component('font-awesome-icon', FontAwesomeIcon)

Vue.use(VueRouter, Bootstrap, Jquery, Popper)
const router = new VueRouter({
  routes: [
    {
      path: '*',
      component: About,
    },
    {
      path: '/resume',
      component: Resume,
    },
    {
      path: '/calculator',
      component: Calculator,
    },
  ],
})

Vue.config.productionTip = false

let app
auth.onAuthStateChanged(() => {
  if (!app) {
    app = new Vue({
      render: (h) => h(App),
      router,
    }).$mount('#app')
  }
})
